// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Styled, Space, CurrencyInput, PercentInput} from '@supermove/components';
import {
  ChargeAmountKind,
  ChargeAmountKindOptions,
  DocumentItemInputChargePaymentType,
} from '@supermove/models';
import {Currency, Percent} from '@supermove/utils';

// App
import DropdownInput from '@shared/design/components/DropdownInput';
import FieldInput from '@shared/design/components/Field/FieldInput';
import {
  DocumentContentJsonType,
  SetDocumentContentJsonType,
} from '@shared/modules/Document/types/DocumentTemplateVersionEditorTypes';

const Row = Styled.View`
  flex-direction: row;
`;

const InputChargePaymentEditorAmountField = ({
  documentItem,
  documentItemField,
  setDraftDocumentContentJson,
}: {
  documentItem: DocumentItemInputChargePaymentType;
  documentItemField: string;
  setDraftDocumentContentJson: SetDocumentContentJsonType;
}) => {
  const selectedAmountKind = documentItem.input.metadata.amountKind
    ? documentItem.input.metadata.amountKind
    : ChargeAmountKind.FIXED;

  const handleFixedAmountChange = (text: string) => {
    const value = Currency.toMutation(text);
    setDraftDocumentContentJson((prevState: DocumentContentJsonType) => {
      _.set(prevState, `${documentItemField}.input.metadata.amountFixedInCents`, value);
      return {...prevState};
    });
  };

  const handlePercentageAmountChange = (text: string) => {
    const value = Percent.toMutation(text);
    setDraftDocumentContentJson((prevState: DocumentContentJsonType) => {
      _.set(prevState, `${documentItemField}.input.metadata.amountPercentageInFraction`, value);
      return {...prevState};
    });
  };

  return (
    <Row>
      <FieldInput
        label={'Default Amount'}
        component={DropdownInput}
        input={{
          placeholder: 'Select Default Amount',
          value: selectedAmountKind,
          options: ChargeAmountKindOptions.map((amountKind) => ({
            label: amountKind.label,
            value: amountKind.value,
          })),
          setFieldValue: (name: string, value: string) => {
            setDraftDocumentContentJson((prevState: DocumentContentJsonType) => {
              _.set(prevState, `${documentItemField}.input.metadata.amountKind`, value);
              _.set(prevState, `${documentItemField}.input.metadata.amountFixedInCents`, undefined);
              _.set(
                prevState,
                `${documentItemField}.input.metadata.amountPercentageInFraction`,
                undefined,
              );
              return {...prevState};
            });
          },
          style: {width: '100%'},
        }}
        isClearable={false}
        isRequired
        isResponsive
        style={{flex: 1}}
      />
      <Space width={16} />
      {selectedAmountKind === ChargeAmountKind.FIXED ? (
        <FieldInput
          label={''}
          component={CurrencyInput}
          input={{
            placeholder: 'Enter default amount',
            type: 'number',
            component: FieldInput.TextInput,
            value: documentItem.input.metadata.amountFixedInCents
              ? Currency.toForm(documentItem.input.metadata.amountFixedInCents)
              : '',
            setFieldValue: (name: string, text: string) => {
              handleFixedAmountChange(text);
            },
            setFieldTouched: () => {},
            style: {width: '100%'},
          }}
          handleBlur={(event) => {
            const text = event.target.value;
            handleFixedAmountChange(text);
          }}
          isClearable={false}
          isResponsive
          style={{flex: 1}}
        />
      ) : (
        <FieldInput
          label={''}
          component={PercentInput}
          input={{
            placeholder: 'Enter percentage',
            type: 'number',
            component: FieldInput.TextInput,
            value: documentItem.input.metadata.amountPercentageInFraction
              ? Percent.toForm(documentItem.input.metadata.amountPercentageInFraction)
              : '',
            setFieldValue: (name: string, text: string) => {
              handlePercentageAmountChange(text);
            },
            setFieldTouched: () => {},
            style: {width: '100%'},
          }}
          handleBlur={(event) => {
            const text = event.target.value;
            handlePercentageAmountChange(text);
          }}
          isClearable={false}
          isResponsive
          style={{flex: 1}}
        />
      )}
    </Row>
  );
};

export default InputChargePaymentEditorAmountField;
